import type { BatchActivateResponse } from '@/api/connectivity/lora';

interface BatchResultToast {
  title: string;
  description: string;
  variant?: 'destructive';
}

// The batch endpoint answers 200 even when every serial is rejected, so the toast must be
// derived from the fulfilled/rejected lists instead of the HTTP status.
export function getBatchResultToast(
  results: BatchActivateResponse['results'],
  type: 'activate' | 'deactivate',
): BatchResultToast {
  const sent = results.fulfilled.length;
  const failed = results.rejected.length;
  const action = type === 'activate' ? 'ativação' : 'desativação';

  if (failed === 0) {
    return {
      title: 'Sucesso!',
      description: `${sent} ${sent === 1 ? 'dispositivo enviado' : 'dispositivos enviados'} para ${action}.`,
    };
  }

  const firstReason = results.rejected[0]?.reason;

  if (sent === 0) {
    return {
      title: `Nenhum dispositivo foi enviado para ${action}`,
      description:
        failed === 1 && firstReason
          ? firstReason
          : `${failed} dispositivos falharam${firstReason ? ` (ex.: ${firstReason})` : ''}.`,
      variant: 'destructive',
    };
  }

  return {
    title: 'Requisição enviada parcialmente',
    description: `${sent} ${sent === 1 ? 'dispositivo enviado' : 'dispositivos enviados'} para ${action} e ${failed} com falha.`,
    variant: 'destructive',
  };
}
